import { render, staticRenderFns } from "./publishItem.vue?vue&type=template&id=609428b4&scoped=true"
import script from "./publishItem.vue?vue&type=script&lang=js"
export * from "./publishItem.vue?vue&type=script&lang=js"
import style0 from "./publishItem.vue?vue&type=style&index=0&id=609428b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609428b4",
  null
  
)

export default component.exports